"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _abp = require("@/api/abp");

var state = {
  abpConfig: null,
  active: 0
};
var mutations = {
  SET_ABPCONFIG: function SET_ABPCONFIG(state, abpConfig) {
    state.abpConfig = abpConfig;
  },
  SET_ACTIVE: function SET_ACTIVE(state, active) {
    state.active = active;
  }
};
var actions = {
  applicationConfiguration: function applicationConfiguration(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      (0, _abp.applicationConfiguration)().then(function (response) {
        commit('SET_ABPCONFIG', response);
        resolve(response);
      })["catch"](function (error) {
        reject(error);
      });
    });
  },
  setActive: function setActive(_ref2, value) {
    var commit = _ref2.commit;
    commit('SET_ACTIVE', value);
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports["default"] = _default;